<section class="embedded-report">
  <a class="embedded-report__home" routerLink="/home" aria-label="Home" title="Home">
    <img src="assets/img/home.png" alt="" />
  </a>
  <div class="embedded-report__content">
    <iframe
      class="embedded-report__frame"
      [src]="reportUrl"
      [title]="reportTitle"
      allowfullscreen>
    </iframe>
  </div>
</section>